import { useState } from 'react'
import * as Styled from './styled'
import AdvancedTooltip from 'common-components/AdvancedTooltip'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import RegenerateIcon from 'assets/svgr-icons/Regenerate.svg'
import DownloadIcon from 'assets/svgr-icons/Download.svg'

interface IPreviewActionButtonsProps {
  onRegenerate: () => void
  onDownload: () => void
  onAddToTimeline: () => void
  showRegenerate?: boolean
}

const PreviewActionButtons = ({
  onRegenerate,
  onDownload,
  onAddToTimeline,
  showRegenerate = true
}: IPreviewActionButtonsProps) => {
  const [regenBtnRef, setRegenBtnRef] = useState<HTMLButtonElement | null>(null)
  const [downloadBtnRef, setDownloadBtnRef] =
    useState<HTMLButtonElement | null>(null)
  return (
    <>
      <Styled.PopupActionsLeft>
        {showRegenerate && (
          <Styled.IconButton ref={setRegenBtnRef} onClick={onRegenerate}>
            <RegenerateIcon />
            <AdvancedTooltip
              btnRef={{ current: regenBtnRef }}
              tooltipText={translate(T.RE_GENERATE)}
              tooltipPosition="top"
            />
          </Styled.IconButton>
        )}
        <Styled.IconButton ref={setDownloadBtnRef} onClick={onDownload}>
          <DownloadIcon />
          <AdvancedTooltip
            btnRef={{ current: downloadBtnRef }}
            tooltipText={translate(T.DOWNLOAD)}
            tooltipPosition="top"
          />
        </Styled.IconButton>
      </Styled.PopupActionsLeft>
      <Styled.AddToTimelineButton type="primary" onClick={onAddToTimeline}>
        <Styled.AddToTimelinePlusIcon />
        {translate(T.ADD_TO_TIMELINE)}
      </Styled.AddToTimelineButton>
    </>
  )
}

export default PreviewActionButtons
